<script>
export default {
    name: "InitiateWaiverForm",

    props: {

        initiateWeiver: Object,
        errors: Array,
        totalBalance: Number,
    },

    watch: {

        totalBalance() {
            this.initiateWeiver.weiverAmount = this.totalBalance;
        },
    },

    mounted() {

        this.initiateWeiver.weiverAmount = this.totalBalance;
    },
}
</script>
<template>
<div class="flex flex-wrap">
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-ref" class="label-control">Ref:</label>
        <input type="text" v-model.trim="initiateWeiver.ref" id="grid-ref" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'ref').length">
            {{ errors.filter(error => error.field == 'ref')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-reason" class="label-control">Reason:</label>
        <input type="text" v-model.trim="initiateWeiver.reason" id="grid-reason" class="input-control input-sm text-xs">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'reason').length">
            {{ errors.filter(error => error.field == 'reason')[0].message }}</p>
    </div>
    <div class="md:w-1/3 sm:w-full p-1">
        <label for="grid-amount" class="label-control">Amount:</label>
        <input type="number" 
            v-model.number="initiateWeiver.weiverAmount" disabled
            id="grid-amount" class="input-control input-sm text-xs text-right disabled">
        <p class="form-text-error" v-if="errors.filter(error => error.field == 'weiverAmount').length">
            {{ errors.filter(error => error.field == 'weiverAmount')[0].message }}</p>
    </div>
    <div class="md:w-2/3 sm:w-full p-1">
        <label for="grid-memo" class="label-control">Memo:</label>
        <input type="text" v-model.trim="initiateWeiver.memo" id="grid-memo" class="input-control input-sm text-xs">
    </div>
</div>
</template>